import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Inventory2 from '@mui/icons-material/Inventory2';
import LocalShipping from '@mui/icons-material/LocalShipping';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import Storefront from '@mui/icons-material/Storefront';
import Assignment from '@mui/icons-material/Assignment';
import PageHeader from '../../Components/PageHeader';

const sections = [
  {
    title: 'Items',
    description: 'Manage product items, SKUs, and status.',
    to: '/chapter-supplies-management/items',
    icon: <Inventory2 />,
  },
  {
    title: 'Vendors',
    description: 'Manage vendors and vendor item links.',
    to: '/chapter-supplies-management/vendors',
    icon: <LocalShipping />,
  },
  {
    title: 'Purchase Orders',
    description: 'Create and receive purchase orders.',
    to: '/chapter-supplies-management/purchase-orders',
    icon: <Assignment />,
  },
  {
    title: 'Inventory',
    description: 'View and adjust inventory levels.',
    to: '/chapter-supplies-management/inventory',
    icon: <ShoppingCart />,
  },
  {
    title: 'Online Items',
    description: 'Manage storefront listings and pricing.',
    to: '/chapter-supplies-management/online-items',
    icon: <Storefront />,
  },
];

export default function ChapterSuppliesLanding() {
  return (
    <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
      <Grid item xs={12}>
        <PageHeader
          title="Chapter Supplies Management"
          leftDom={undefined}
          rightDom={undefined}
          subtitle={undefined}
        />
      </Grid>
      <Grid item xs={12} sx={{ minHeight: 0, overflow: 'visible' }}>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          {sections.map(({ title, description, to, icon }) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={to}
              sx={{ minHeight: '150px', maxHeight: '250px' }}
            >
              <Link
                component={RouterLink}
                to={to}
                underline="none"
                color="inherit"
              >
                <Paper
                  sx={{
                    p: 2,
                    height: '75%',
                    cursor: 'pointer',
                    '&:hover': { bgcolor: 'action.hover' },
                  }}
                  elevation={2}
                >
                  <Typography color="primary" sx={{ mb: 1 }}>
                    {icon}
                  </Typography>
                  <Typography variant="h6" gutterBottom>
                    {title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {description}
                  </Typography>
                </Paper>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
